import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'CardContainer',
  props: {
  title: {
    type: String,
    required: true,
  },
  logoUrl: {
    type: String,
    default: "/logo_red.svg",
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})